import { render } from "./TrendingUpIcon.vue?vue&type=template&id=7e07812a"
const script = {}
script.render = render

export default script